
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/copyright",
      function () {
        return require("private-next-pages/about/copyright/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/copyright"])
      });
    }
  